import React from 'react';

import { ButtonPriority, ButtonSize, PaddingModes } from 'wix-ui-tpa';
import { Button } from 'wix-ui-tpa/cssVars';

import { st, classes } from './WidgetButton.st.css';

export const enum WidgetButtonPriority {
  basic = ButtonPriority.basic,
  primary = ButtonPriority.primary,
  secondary = ButtonPriority.secondary,
}

export const toButtonPriority = (
  priority: WidgetButtonPriority,
): ButtonPriority => {
  return priority === WidgetButtonPriority.primary
    ? ButtonPriority.primary
    : ButtonPriority.secondary;
};
export const enum WidgetButtonSize {
  medium = ButtonSize.medium,
  tiny = ButtonSize.tiny,
}

export const toButtonSize = (size: WidgetButtonSize): ButtonSize => {
  return size === WidgetButtonSize.medium ? ButtonSize.medium : ButtonSize.tiny;
};

export const WidgetButton: React.FC<{
  text: string;
  title?: string;
  onClick: () => void;
  priority?: WidgetButtonPriority;
  fullWidth?: boolean;
  size?: WidgetButtonSize;
  paddingMode?: PaddingModes;
  disabled?: boolean;
  selected?: boolean;
}> = ({
  text,
  title = text,
  onClick,
  priority = WidgetButtonPriority.primary,
  fullWidth = false,
  size = WidgetButtonSize.medium,
  paddingMode,
  disabled,
  selected,
}) => {
  return (
    <Button
      className={st(classes.root, {
        priority,
        size,
        fullWidth,
        disabled,
        selected,
      })}
      title={title}
      onClick={onClick}
      paddingMode={paddingMode}
      priority={toButtonPriority(priority)}
      fullWidth={fullWidth}
      size={toButtonSize(size)}
      wrapContent
      disabled={disabled}
    >
      {text}
    </Button>
  );
};
